import { View } from "react-native";
import PageHeader from "./page-header";
import { LucideIcon } from "lucide-react-native";

interface PageTemplateProps {
  withHeader?: boolean;
  title?: string;
  headerIcon?: LucideIcon;
  children: React.ReactNode;
  className?: string;
}

export default function PageTemplate({
  withHeader = true,
  title,
  headerIcon: Icon,
  children,
  className = "",
}: PageTemplateProps) {
  return (
    <View className="flex-1 bg-[#FDFDFE]">
      <View className="flex-1">
        {withHeader && <PageHeader title={title ?? ""} headerIcon={Icon} />}
        <View className={`flex-1 ${className}`}>{children}</View>
      </View>
    </View>
  );
}
